import { gql } from "@apollo/client";

export const SERVICE_FIELDS = gql`
  fragment ServiceFields on ServiceRecord {
    id
    slug
    icon {
      iconName
    }
    title
    shortTitle
    shortIntro {
      value
    }
    hideServiceFromOverview
    intro {
      value
    }
    parent {
      slug
    }
    children {
      slug
      shortTitle
      intro {
        value
      }
      icon {
        iconName
      }
      shortIntro {
        value
      }
      title
    }
    # Add titles and slugs for AppContext
    titles: _allTitleLocales {
      locale
      value
    }
    slugs: _allSlugLocales {
      locale
      value
    }
  }
`;

export const SERVICE_HERO_LOGO = gql`
  fragment ServiceHeroLogo on ServiceRecord {
    heroLogo {
      id
      responsiveImage(
        imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "1560", h: "500", q: "75" }
      ) {
        alt
        height
        src
        title
        width
      }
    }
  }
`;

export const SERVICE_OVERVIEW_FIELDS = gql`
  fragment ServiceOverviewFields on ServicesOverviewRecord {
    title
    shortTitle
    smallIntro
    intro {
      value
    }
    # Add titles and slugs for AppContext
    titles: _allTitleLocales {
      locale
      value
    }
  }
`;
